module.exports = __webpack_public_path__ + "img/spongebob-pointing-finger.a56dea8d.webp";